<div class="container-fluid">
  <div class="container-fluid container-shadow my-4" *ngIf="vendorLoading">
    <div class="text-center py-5">
      <i class="fas fa-spinner fa-3x fa-fw fa-pulse"></i>
    </div>
  </div>
  <div class="container-fluid container-shadow my-4" *ngIf="!vendorLoading">
    <h2 class="pt-4 text-center">
      <div class="float-left pt-2">
        <h6>
          <a href="javascript: void(0)" (click)="goBack()"><i class="fas fa-arrow-left"></i>&nbsp;Back</a>
        </h6>
      </div>
      <div class="pull-right float-right pt-2">
        <h6><a [routerLink]="'/vendors'">Vendors Index</a></h6>
      </div>
      Vendor - <a title="View contact" [href]="'/contacts/' + vendor.contact_id">{{ vendor.contact_name }}</a>
    </h2>
    <hr class="mt-1 mb-3" />
    <div class="row">
      <div class="col-sm-6 col-md-5">
        <div class="float-left">
          <a [routerLink]="'/vendors/' + vendor.id + '/edit'" class="btn btn-outline-primary">Edit</a>
          &nbsp;
          <button type="button" class="btn btn-outline-danger" (click)="deleteVendorModal(delete_vendor_modal)">Delete</button>
        </div>
        <div class="pull-right float-right">
          <app-badge badgeType="success" *ngIf="vendor.is_auto_withdrawal">Auto W/D</app-badge>
          <span *ngIf="vendor.is_priority && vendor.is_auto_withdrawal">&nbsp;</span>
          <app-badge badgeType="danger" *ngIf="vendor.is_priority">Is a priority</app-badge>
        </div>
        <div class="clearfix my-2"></div>
        <p class="p-2 mb-2 bg-primary text-white">
          <b>Account #</b>&nbsp;<span>{{ vendor.account_number }}</span>
        </p>
        <p class="p-2 mb-2 bg-info text-white">
          <b>Address:</b><br />
          <span [innerHTML]="vendor.full_address | safeHtml"></span>
        </p>
        <p class="p-2 mb-2 bg-success text-white">
          <b>Chart of Account:</b><br />
          <span>{{ vendor.chart_of_account_name }}</span>
        </p>
        <div class="card">
          <div class="card-header">Add Matter</div>
          <div class="card-block p-2">
            <div class="form-group">
              <app-matter-search [select_only]="true" [include_item]="true" (matter)="onMatterSelect($event)"></app-matter-search>
              <div class="form-text" *ngIf="selectedMatterId">
                <b>Selected Matter:&nbsp;</b>
                <br />
                <a [routerLink]="'/matters/' + selectedMatterId">{{ selectedMatterName }}</a>
                <br />
                <div class="py-1"></div>
                <button (click)="addMatter()" type="button" class="btn btn-primary btn-sm">Add this matter</button>
                &nbsp;
                <button (click)="cancelMatterAdd()" type="button" class="btn btn-secondary btn-sm">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-7" style="position: relative">
        <div class="p-2 bg-warning" *ngIf="vendor.matters.length < 1">This vendor is not involved in any matter</div>
        <div *ngIf="vendor.matters.length > 0">
          <h4 class="py-2">
            Matters Involved: <app-badge badgeType="primary">{{ vendor.matters.length }}</app-badge>
          </h4>
          <div class="py-1 mb-2" *ngFor="let matter of vendor.matters">
            <div class="pull-right float-right">
              <a href="javascript:void(0)" class="text-danger" (click)="removeMatterModal(remove_matter_modal, matter)">
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="float-left">
              <div style="height: 16px !important; margin-right: 0px !important" title="Show to be paids below for this matter" (click)="matter.show_to_be_paids = !matter.show_to_be_paids; matterFilterChange(matter)" class="custom-control custom-checkbox custom-control-inline">
                <input [checked]="matter.show_to_be_paids" [(ngModel)]="matter.show_to_be_paids" type="checkbox" class="custom-control-input" />
                <label class="custom-control-label"></label>
              </div>
            </div>
            <div class="float-left">
              <a [routerLink]="'/matters/' + matter.id">{{ matter.full_name }}</a>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="invisible row border border-secondary border-bottom-0 border-left-0 border-right-0">
          <div class="col-4 pt-2">
            <h5>Total charge</h5>
            <h5 class="p-2 bg-info text-white">{{ vendor.total_charges | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
          <div class="col-4 pt-2">
            <h5>Total payments</h5>
            <h5 class="p-2 bg-success text-white">{{ vendor.total_payments | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
          <div class="col-4 pt-2">
            <h5>Total balance</h5>
            <h5 class="p-2 bg-warning text-white">{{ vendor.total_balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
        </div>
        <div style="position: absolute; bottom: 0; width: 100%" class="row">
          <div style="border-color: #e5e5e5 !important" class="col-4 border border-secondary pt-1 border-bottom-0 border-left-0 border-right-0">
            <h5>Total charge</h5>
            <h5 class="p-2 bg-info text-white">{{ vendor.total_charges | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
          <div style="border-color: #e5e5e5 !important" class="col-4 border border-secondary pt-1 border-bottom-0 border-left-0 border-right-0">
            <h5>Total payments</h5>
            <h5 class="p-2 bg-success text-white">{{ vendor.total_payments | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
          <div style="border-color: #e5e5e5 !important" class="col-4 border border-secondary pt-1 border-bottom-0 border-left-0 border-right-0">
            <h5>Total balance</h5>
            <h5 class="p-2 bg-warning text-white">{{ vendor.total_balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
          </div>
        </div>
      </div>
    </div>
    <h4 class="pb-2 mt-4 pl-3">
      <div class="float-right">
        <a [routerLink]="'/to_be_paids'" [queryParams]="{ contact_name: vendor.contact_name, make_payment: true, vendor_id: vendor.id }" class="btn btn-outline-primary">Make Payment</a>
      </div>
      To be paid <app-badge badgeType="primary">{{ to_be_paids_count }}</app-badge>
    </h4>
    <hr class="my-2" />
    <div class="row">
      <div class="col-8 border border-secondary border-top-0 border-bottom-0 border-left-0" style="border-color: #e5e5e5 !important">
        <span style="font-weight: normal !important">
          <div (click)="to_be_paid_search_params.O = !to_be_paid_search_params.O; loadToBePaids()" style="cursor: pointer; min-width: 140px" class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="to_be_paid_search_params.O" [(ngModel)]="to_be_paid_search_params.O" />
            <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-warning">outstanding</label>
          </div>
        </span>
        <span style="font-weight: normal !important">
          <div (click)="to_be_paid_search_params.P = !to_be_paid_search_params.P; loadToBePaids()" style="cursor: pointer; min-width: 140px" class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="to_be_paid_search_params.P" [(ngModel)]="to_be_paid_search_params.P" />
            <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-success">paid</label>
          </div>
        </span>
        <span style="font-weight: normal !important">
          <div (click)="to_be_paid_search_params.C = !to_be_paid_search_params.C; loadToBePaids()" style="cursor: pointer; min-width: 140px" class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="to_be_paid_search_params.C" [(ngModel)]="to_be_paid_search_params.C" />
            <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-danger">contested</label>
          </div>
        </span>
        <span style="font-weight: normal !important">
          <div (click)="to_be_paid_search_params.V = !to_be_paid_search_params.V; loadToBePaids()" style="cursor: pointer; min-width: 140px" class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="to_be_paid_search_params.V" [(ngModel)]="to_be_paid_search_params.V" />
            <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-dark">void</label>
          </div>
        </span>
      </div>
      <div class="col-4">
        <div class="pull-right float-right">
          <pagination
            [boundaryLinks]="true"
            [maxSize]="5"
            [itemsPerPage]="to_be_paid_search_params.per_page"
            [totalItems]="to_be_paids_count"
            (pageChanged)="toBePaidPageChanged($event)"
            [(ngModel)]="to_be_paid_search_params.page"
            class="pagination-sm"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;"
          ></pagination>
        </div>
        <div class="pull-right float-right">
          <button type="button" (click)="togglePaymentsShow()" class="btn btn-outline-secondary btn-sm">{{ showPayments ? 'Hide' : 'Show' }}&nbsp;Payments</button>
          &nbsp;
        </div>
      </div>
    </div>
    <hr class="mt-2 mb-0" />
    <hr class="mt-0 mb-2" />
    <div class="row font-weight-bold mx-0">
      <div class="col-1 pb-2"></div>
      <div class="col-2 pl-0 pb-2">Date</div>
      <div class="col-1 pb-2" *ngIf="vendor.matters.length != 1">Matter</div>
      <div class="pb-2" [ngClass]="{ 'col-5': vendor.matters.length == 1, 'col-4': vendor.matters.length != 1 }">Document</div>
      <div class="col-1 pb-2 text-center">Status</div>
      <div class="col-1 pb-2">Charge</div>
      <div class="col-1 pb-2">Payment</div>
      <div class="col-1 pb-2">Balance</div>
    </div>
    <div class="row mx-0 py-2 border border-dark mb-1" *ngFor="let to_be_paid of to_be_paids; let odd = odd; let even = even" [ngStyle]="{ background: even ? 'rgba(0, 0, 0, 0.05)' : '' }">
      <div class="col-12">
        <div class="row">
          <div class="col-1">
            <h6>&nbsp;<span *ngIf="to_be_paid.payments.length > 0">&nbsp;&nbsp;&nbsp;</span>Charge</h6>
          </div>
          <div class="col-2 pl-0">
            <a [title]="to_be_paid.created_at" [routerLink]="'/to_be_paids/' + to_be_paid.id + '/edit'">{{ to_be_paid.created_at_date }}</a>
          </div>
          <div class="col-1" *ngIf="vendor.matters.length != 1">
            <a *ngIf="to_be_paid.matter_id" [href]="'/matters/' + to_be_paid.matter_id">{{ to_be_paid.matter_number }}</a>
          </div>
          <div class="" [ngClass]="{ 'col-5': vendor.matters.length == 1, 'col-4': vendor.matters.length != 1 }">
            <span *ngIf="!to_be_paid.is_charge && to_be_paid.check_number">Check&nbsp;#</span><a *ngIf="to_be_paid.document_url" [href]="to_be_paid.document_url">{{ to_be_paid.document_text }}</a>
            <span *ngIf="!to_be_paid.document_url && to_be_paid.document_text">{{ to_be_paid.document_text }}</span>
            <span *ngIf="!to_be_paid.document_url && !to_be_paid.document_text && to_be_paid.bill_type_name == 'payment'" class="text-warning">None</span>
            <span *ngIf="!to_be_paid.document_url && !to_be_paid.document_text && to_be_paid.bill_type_name == 'charge'" class="text-muted">N/A</span>
            <br *ngIf="to_be_paid.description" />
            <span>{{ to_be_paid.description }}</span>
          </div>
          <div class="col-1">
            <app-badge *ngIf="to_be_paid.status_name" [badgeType]="statusName(to_be_paid.status_name)" style="width: 100% !important">{{ to_be_paid.status_name }}</app-badge>
          </div>
          <div class="col-1">
            <span>{{ to_be_paid.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </div>
          <div class="col-1">
            <span>{{ to_be_paid.paid | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </div>
          <div class="col-1 pr-0">
            <div class="float-right pr-1">
              <i class="fas fa-exclamation-circle text-danger" *ngIf="to_be_paid.is_priority"></i>
            </div>
            <span>{{ to_be_paid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-2">
            <h6>
              <a href="javascript: void(0)" *ngIf="to_be_paid.payments.length > 0" (click)="to_be_paid.show_payments = !to_be_paid.show_payments"><i class="fas" [ngClass]="{ 'fa-plus-circle': !to_be_paid.show_payments, 'fa-minus-circle': to_be_paid.show_payments }"></i></a
              ><span *ngIf="to_be_paid.payments.length > 0">&nbsp;</span>Payments <app-badge badgeType="primary">{{ to_be_paid.payments.length }}</app-badge>
            </h6>
          </div>
          <div class="col-7 py-0 mb-2" *ngIf="to_be_paid.show_payments && to_be_paid.payments.length > 0">
            <div class="card border border-secondary bg-light">
              <div class="card-body">
                <div class="row">
                  <div class="col-2 pl-1">
                    <strong>Date</strong>
                  </div>
                  <div class="col-6">
                    <strong>Document</strong>
                  </div>
                  <div class="col-2 text-center">
                    <strong>Status</strong>
                  </div>
                  <div class="col-2 pr-1">
                    <strong>Payment</strong>
                  </div>
                </div>
                <hr />
                <div class="row" *ngFor="let to_be_paid_payment of to_be_paid.payments">
                  <div class="col-2 pl-1">
                    <a [title]="to_be_paid_payment.created_at" [routerLink]="'/to_be_paids/' + to_be_paid_payment.id + '/edit'">{{ to_be_paid_payment.created_at_date }}</a>
                  </div>
                  <div class="col-6">
                    <span *ngIf="!to_be_paid_payment.is_charge && to_be_paid_payment.check_number">Check&nbsp;#</span><a *ngIf="to_be_paid_payment.document_url" [href]="to_be_paid_payment.document_url">{{ to_be_paid_payment.document_text }}</a>
                    <span *ngIf="!to_be_paid_payment.document_url && to_be_paid_payment.document_text">{{ to_be_paid_payment.document_text }}</span>
                    <span *ngIf="!to_be_paid_payment.document_url && !to_be_paid_payment.document_text && to_be_paid_payment.bill_type_name == 'payment'" class="text-warning">None</span>
                    <span *ngIf="!to_be_paid_payment.document_url && !to_be_paid_payment.document_text && to_be_paid_payment.bill_type_name == 'charge'" class="text-muted">N/A</span>
                    <br *ngIf="to_be_paid_payment.description" />
                    <span>{{ to_be_paid_payment.description }}</span>
                  </div>
                  <div class="col-2">
                    <app-badge *ngIf="to_be_paid_payment.status_name" [badgeType]="statusName(to_be_paid_payment.status_name)" style="width: 100% !important">{{ to_be_paid_payment.status_name }}</app-badge>
                  </div>
                  <div class="col-2 pr-1">
                    <span *ngIf="to_be_paid_payment.is_payment">{{ to_be_paid_payment.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-2"></div>
  </div>
</div>
<ng-template #delete_vendor_modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-danger">Delete vendor</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Confirm vendor deletion</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('delete')">Confirm delete</button>
    <button type="button" class="btn btn-outline-secondary" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>
<ng-template #remove_matter_modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-danger">Remove matter</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Confirm matter removal
      <span *ngIf="matterToBeRemoved">
        &nbsp;
        <a target="_blank" [href]="'/matters/' + matterToBeRemoved.id">{{ matterToBeRemoved.full_name }}</a>
        &nbsp;
      </span>
      ?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('remove')">Confirm</button>
    <button type="button" class="btn btn-outline-secondary" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>
